/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  MemoryStoreVisibility,
  MemoryStoreVisibility$inboundSchema,
  MemoryStoreVisibility$outboundSchema,
} from "./memorystorevisibility.js";

export type CreateMemoryStoreRequest = {
  name: string;
  description?: string | null | undefined;
  instructions?: string | null | undefined;
  visibility?: MemoryStoreVisibility | undefined;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const CreateMemoryStoreRequest$inboundSchema: z.ZodType<
  CreateMemoryStoreRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
  description: z.nullable(z.string()).optional(),
  instructions: z.nullable(z.string()).optional(),
  visibility: MemoryStoreVisibility$inboundSchema.optional(),
  metadata: z.record(z.string()).optional(),
});
/** @internal */
export type CreateMemoryStoreRequest$Outbound = {
  name: string;
  description?: string | null | undefined;
  instructions?: string | null | undefined;
  visibility?: string | undefined;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const CreateMemoryStoreRequest$outboundSchema: z.ZodType<
  CreateMemoryStoreRequest$Outbound,
  z.ZodTypeDef,
  CreateMemoryStoreRequest
> = z.object({
  name: z.string(),
  description: z.nullable(z.string()).optional(),
  instructions: z.nullable(z.string()).optional(),
  visibility: MemoryStoreVisibility$outboundSchema.optional(),
  metadata: z.record(z.string()).optional(),
});

export function createMemoryStoreRequestToJSON(
  createMemoryStoreRequest: CreateMemoryStoreRequest,
): string {
  return JSON.stringify(
    CreateMemoryStoreRequest$outboundSchema.parse(createMemoryStoreRequest),
  );
}
export function createMemoryStoreRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateMemoryStoreRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateMemoryStoreRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateMemoryStoreRequest' from JSON`,
  );
}
